import React from 'react';
import {Link} from 'react-router-dom';
import styles from './MenuPanel.module.css';

// Shared popover shell for the account and mobile "more" menus.
export const MenuPanel = React.forwardRef(({children, align = 'end', label}, ref) => (
    <div ref={ref} role="menu" aria-label={label} className={`${styles.panel} ${styles[align]}`}>
        {children}
    </div>
));

const rowProps = (danger) => ({
    role: 'menuitem',
    tabIndex: 0,
    className: `${styles.item} ${danger ? styles.danger : ''}`,
});

export const MenuLink = ({to, danger, children, ...rest}) => (
    <Link to={to} {...rowProps(danger)} {...rest}>{children}</Link>
);

export const MenuButton = ({onClick, danger, children, ...rest}) => (
    <button type="button" onClick={onClick} {...rowProps(danger)} {...rest}>{children}</button>
);

export const MenuDivider = () => <div className={styles.divider}/>;

export const MenuLabel = ({children}) => <div className={styles.label}>{children}</div>;
